import { Directive, ElementRef, OnInit, AfterViewInit, HostListener, Input, inject } from '@angular/core';
import { Tooltip } from 'primeng/tooltip';
import { GlobalConstants } from 'src/app/base/global.constants';

@Directive({
  selector: '[title]:not([pTooltip])',
  standalone: false, //NOSONAR
  hostDirectives: [
    {
      directive: Tooltip,
      inputs: ['pTooltip: title']
    }
  ]
})
export class NativeTitleOverrideDirective implements OnInit, AfterViewInit {
  private readonly el = inject(ElementRef);
  private readonly tooltip = inject(Tooltip, { self: true });

  @Input()
  set title(val: string) {
    this.removeNativeTitle();
  }

  @HostListener('mouseenter')
  onMouseEnter(): void {
    this.removeNativeTitle();
  }

  ngOnInit(): void {
    this.tooltip.showDelay = GlobalConstants.tooltipShowDelay!;
    this.tooltip.tooltipPosition = GlobalConstants.tooltipPosition!;

    // Update the internal options state PrimeNG specifically relies on
    if (typeof this.tooltip.setOption === 'function') {
      this.tooltip.setOption({
        showDelay: GlobalConstants.tooltipShowDelay,
        tooltipPosition: GlobalConstants.tooltipPosition
      });
    }
  }

  ngAfterViewInit(): void {
    this.removeNativeTitle();
  }

  private removeNativeTitle(): void {
    // Prevent default slow browser tooltip from rendering
    setTimeout(() => {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      if (this.el?.nativeElement) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        this.el.nativeElement.title = '';
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        if (typeof this.el.nativeElement.removeAttribute === 'function') {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
          this.el.nativeElement.removeAttribute('title');
        }
      }
    });
  }
}
